import React from 'react';
import { DatasetListItem } from 'types/Dataset';
import Card from 'components/card/Card';
import DatasetCardBody from './components/DatasetCardBody';
import { useRecentlyViewed } from 'views/HomePage/recentlyViewed/RecentlyViewedProvider';

const DatasetCard = ({
    label,
    statistics,
    description,
    created,
    updated,
    datasetUri,
    status,
    confidentiality,
}: DatasetListItem) => {
    const { addToRecentlyViewed } = useRecentlyViewed();

    return (
        <Card
            onClick={() => addToRecentlyViewed(datasetUri)}
            label={label}
            uri={`/dataset/${datasetUri}/`}
            body={
                <DatasetCardBody
                    statistics={statistics}
                    status={status}
                    confidentiality={confidentiality}
                />
            }
            type="dataset"
            description={description}
            updated={updated || created}
        />
    );
};

export default DatasetCard;
